module.exports = __webpack_public_path__ + "img/hr-heated-ending-down-1.09abbeb3.png";